import { gql } from "graphql-request"

export default gql`
    query ($siteId: [QueryArgument]) {
        flatmenu: entries(section: "auxiliaryMenu", siteId: $siteId) {
            id
            title
            slug
            typeHandle
            parent(status: null) {
                id
            }
            ... on null_Entry {
                highlight
                class
                userStatus
                submenuType
                backgroundImage {
                    url
                }
                leftPanelContent
                rightPanelContent
            }
            ... on subhead_Entry {
                highlight
                class
                userStatus
            }
            ... on path_Entry {
                highlight
                class
                openInNewTab
                userStatus
                navigationPath
            }
            ... on link_Entry {
                string
                highlight
                class
                userStatus
            }
            ... on htmlPage_Entry {
                highlight
                class
                openInNewTab
                userStatus
                page {
                    slug
                }
            }
            ... on action_Entry {
                highlight
                class
                userStatus
                menuItemHandler
            }
            ... on navigation_channels_Entry {
                userStatus
                class
                highlight
            }
        }
    }
`
